import React, { useState, useEffect } from 'react';
import { Content, Lesson } from '../../../../../../types';
import SectionContent from '../section-content/SectionContent';
import { useEditUnit } from '../../../edit/useEditUnit';
import {
  Droppable,
  Draggable,
  DraggableProvided,
  DroppableProvided,
  DraggableStateSnapshot
} from 'react-beautiful-dnd';

type Props = {
  contents: Content[];
  lesson?: Lesson;
  isSupportingMaterial?: boolean;
};

function SectionContents(props: Props) {
  const { contents, lesson, isSupportingMaterial } = props;
  const [ localContents, setLocalContents ] = useState<Array<Content>>(contents);
  const { content: selectedContent, lesson: selectedLesson } = useEditUnit();

  useEffect(() => {
    setLocalContents(contents ?? []);
  }, [contents])

  if (!lesson) return null;

  return (
    <Droppable droppableId={isSupportingMaterial ? `material-${lesson!.id}` : lesson!.id } type={isSupportingMaterial ? "droppableMaterialItem" : "droppableModuleItem"}>
      {(droppableProvided: DroppableProvided) => (
        <div
          ref={droppableProvided.innerRef}
          {...droppableProvided.droppableProps}
        >
          {localContents.length > 0 ?
            localContents.map((item: Content, index: number) => (
              <Draggable
                key={item.id}
                draggableId={item.id}
                index={index}
              >
                {(
                  draggableProvided: DraggableProvided,
                  snapshot: DraggableStateSnapshot
                ) => {
                  const sectionSelected = selectedContent?.id === item.id && selectedLesson?.id === lesson?.id;
                  return (
                    <div
                      ref={draggableProvided.innerRef}
                      {...draggableProvided.draggableProps}
                    >
                      <SectionContent draggableProvided={draggableProvided} snapshot={snapshot} lesson={lesson} key={item.id} selected={sectionSelected} content={item} isSupportingMaterial={isSupportingMaterial}/>
                    </div>
                  );
                }}
              </Draggable>
            )) :
            <div style={{color:'white', height:'1px'}}>{}</div>}
          {droppableProvided.placeholder}
        </div>
      )}
    </Droppable>
  );
}

export default SectionContents;
